import { type Translated } from '@myre/common-i18n';

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { FooterItem } from '../footer-item.component';

@Component({
  selector: 'myre-footer-text',
  templateUrl: './footer-text.component.html',
  styleUrls: [
    '../../footer-item.component.scss',
    './footer-text.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class FooterTextComponent extends FooterItem {
  @Input()
  public redirectUrl: string | string[];

  @Input()
  public value: Translated;
}
